export const timezones = [
  { value: 'Pacific/Kwajalein', label: 'Pacific/Kwajalein (UTC-12:00)' },
  { value: 'Pacific/Pago_Pago', label: 'Pacific/Pago_Pago (UTC-11:00)' },
  { value: 'Pacific/Honolulu', label: 'Pacific/Honolulu (UTC-10:00)' },
  { value: 'America/Anchorage', label: 'America/Anchorage (UTC-09:00)' },
  { value: 'America/Los_Angeles', label: 'America/Los_Angeles (UTC-08:00)' },
  { value: 'America/Denver', label: 'America/Denver (UTC-07:00)' },
  { value: 'America/Chicago', label: 'America/Chicago (UTC-06:00)' },
  { value: 'America/New_York', label: 'America/New_York (UTC-05:00)' },
  { value: 'America/Santiago', label: 'America/Santiago (UTC-04:00)' },
  { value: 'America/Argentina/Buenos_Aires', label: 'America/Argentina/Buenos_Aires (UTC-03:00)' },
  { value: 'Atlantic/South_Georgia', label: 'Atlantic/South_Georgia (UTC-02:00)' },
  { value: 'Atlantic/Azores', label: 'Atlantic/Azores (UTC-01:00)' },
  { value: 'Europe/London', label: 'Europe/London (UTC±00:00)' },
  { value: 'Europe/Amsterdam', label: 'Europe/Amsterdam (UTC+01:00)' },
  { value: 'Europe/Athens', label: 'Europe/Athens (UTC+02:00)' },
  { value: 'Europe/Moscow', label: 'Europe/Moscow (UTC+03:00)' },
  { value: 'Asia/Dubai', label: 'Asia/Dubai (UTC+04:00)' },
  { value: 'Asia/Karachi', label: 'Asia/Karachi (UTC+05:00)' },
  { value: 'Asia/Dhaka', label: 'Asia/Dhaka (UTC+06:00)' },
  { value: 'Asia/Bangkok', label: 'Asia/Bangkok (UTC+07:00)' },
  { value: 'Asia/Shanghai', label: 'Asia/Shanghai (UTC+08:00)' },
  { value: 'Asia/Tokyo', label: 'Asia/Tokyo (UTC+09:00)' },
  { value: 'Australia/Sydney', label: 'Australia/Sydney (UTC+10:00)' },
];
